import { inject, Injectable, signal } from '@angular/core';
import { ScanRepository } from '../repositories/scan.repository';

@Injectable()
export class ScanService {
  #scanRepository = inject(ScanRepository);
  readonly loading = signal(false);

  async scan(type, bardcode): Promise<any> {
    return await this.#scanRepository.retrieve(type, bardcode);
  }
}
